
<!--<pre class="small" style="position: absolute; top: 0; left: 0; background: rgba(0,0,0,.1); z-index: 9999;">-->
<!--  {{scaleFactor}}-->
<!--</pre>-->

<div #wrapper
     class="wrapper overflow-hidden"
     [style.width.px]="wrapperWidth"
     [style.height.px]="wrapperHeight">

    <div class="dropzone-wrapper">

      <div class="scale"
           [style.transform]="'scale(' + scaleFactor + ')'"
           style="transform-origin: top left">

        <app-drop-zone [parent]="block"
                       [scaleFactor]="scaleFactor"
                       [style.width.px]="dropZoneWidth"
                       [style.height.px]="dropZoneHeight"
                       absoluteDropZone>

          <pl-pdf-part-child *ngFor="let child of block.children"
                             absoluteDrag
                             resizable
                             [constraintAspectRatio]="child.settings.aspectRatio"
                             [resizableParentRect]="wrapper.getBoundingClientRect()"
                             [resizableScaleFactor]="scaleFactor"
                             [resizeAxis]="child.settings.resizeAxis"
                             [minSize]="child.settings.minSize"
                             [maxSize]="child.settings.maxSize"
                             (resized)="childResized($event, child)"
                             (sizeChanged)="child.settings.absoluteSize = $event"
                             [block]="child"
                             [class.block-selected]="selectedBlockId === child.id"
                             [style.top.px]="child.settings.absolutePosition?.y ?? 0"
                             [style.left.px]="child.settings.absolutePosition?.x ?? 0"
                             [style.width]="!!child?.settings?.absoluteSize?.width ? child?.settings?.absoluteSize?.width + 'px' : 'auto'"
                             [style.height]="!!child?.settings?.absoluteSize?.height ? child?.settings?.absoluteSize?.height + 'px' : 'auto'"
                             style="--dynamic-border-size: {{child.settings.dynamicBorderSize}}px">
          </pl-pdf-part-child>

        </app-drop-zone>

        <picture>
          <source [srcset]="srcsetWebp" type="image/webp">
          <source [srcset]="srcsetPng" type="image/png">
          <img #imageElement
               loading="lazy"
               class="display-img"
               [src]="previewPngUrl"
               [style.width.px]="dropZoneWidth"
               [style.height.px]="dropZoneHeight">
        </picture>

      </div>

    </div>

</div>

<picture>
  <source [srcset]="srcsetWebp" type="image/webp">
  <source [srcset]="srcsetPng" type="image/png">
  <img #referenceImage
       loading="lazy"
       class="reference-img"
       [srcset]="previewPngUrl"
       [style.width.pt]="refImageWidth"
       [style.height.pt]="refImageHeight">
</picture>
